import { isLocal, hostName, getBackendBaseUrl } from './apiEnv';
import { uiRouts } from './uiRouts';
import { apiRouts } from './apiRouts';

export { uiRouts, apiRouts, isLocal, hostName, getBackendBaseUrl };
